
    const data = {"name":"src/core/icons/information-box","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M5 3h14a2 2 0 0 1 2 2v14c0 .53-.21 1.04-.59 1.41-.37.38-.88.59-1.41.59H5c-.53 0-1.04-.21-1.41-.59C3.21 20.04 3 19.53 3 19V5c0-1.11.89-2 2-2m8 6V7h-2v2h2m0 8v-6h-2v6h2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            